import Loadable from './Loadable';

const PATH_PREFIX = '/product/:companyID';

export default [
  {
    name: 'product.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
    exact: true,
    component: Loadable(import('../ui/apps/product/dashboard')),
  },
  {
    name: 'product.categories',
    path: `${PATH_PREFIX}/categories`,
    exact: true,
    component: Loadable(import('../ui/apps/product/category/list')),
  },
  {
    name: 'product.category',
    path: `${PATH_PREFIX}/categories/:docID`,
    exact: true,
    component: Loadable(import('../ui/apps/product/category/detail')),
  },
  {
    name: 'product.list',
    path: `${PATH_PREFIX}/products`,
    exact: true,
    component: Loadable(import('../ui/apps/product/list')),
  },
  {
    name: 'product.import',
    path: `${PATH_PREFIX}/import/product`,
    exact: true,
    component: Loadable(import('../ui/apps/product/importProduct')),
  },
  {
    name: 'product.import.image',
    path: `${PATH_PREFIX}/import/image`,
    exact: true,
    component: Loadable(import('../ui/apps/product/importImage')),
  },
  {
    name: 'product.information',
    path: `${PATH_PREFIX}/products/:docID/information`,
    exact: true,
    component: Loadable(import('../ui/apps/product/detail/information')),
  },
  {
    name: 'product.variation',
    path: `${PATH_PREFIX}/products/:docID/variation`,
    exact: true,
    component: Loadable(import('../ui/apps/product/detail/variation')),
  },
  {
    name: 'product.description',
    path: `${PATH_PREFIX}/products/:docID/detail`,
    exact: true,
    component: Loadable(import('../ui/apps/product/detail/description')),
  },
  {
    name: 'product.ecommerce',
    path: `${PATH_PREFIX}/products/:docID/ecommerce`,
    exact: true,
    component: Loadable(import('../ui/apps/product/detail/ecommerce')),
  },
  {
    name: 'product.packaging',
    path: `${PATH_PREFIX}/products/:docID/packaging`,
    exact: true,
    component: Loadable(import('../ui/apps/product/detail/packaging')),
  },
  {
    name: 'product.inventory',
    path: `${PATH_PREFIX}/products/:docID/inventory`,
    exact: true,
    component: Loadable(import('../ui/apps/product/detail/inventory')),
  },
  {
    name: 'product.shipment',
    path: `${PATH_PREFIX}/products/:docID/shipment`,
    exact: true,
    component: Loadable(import('../ui/apps/product/detail/shipment')),
  },
  {
    name: 'product.media',
    path: `${PATH_PREFIX}/products/:docID/media`,
    exact: true,
    component: Loadable(import('../ui/apps/product/detail/media')),
  },
  {
    name: 'product.developer.overwrite',
    path: `${PATH_PREFIX}/products/:docID/developer/overwrite`,
    exact: true,
    component: Loadable(import('../ui/apps/product/detail/developerOverwrite')),
  },
  {
    name: 'product.developer.schemaMarkup',
    path: `${PATH_PREFIX}/products/:docID/developer/schemaMarkup`,
    exact: true,
    component: Loadable(
      import('../ui/apps/product/detail/developerSchemaMarkup')
    ),
  },
  {
    name: 'product.subdirectory',
    path: `${PATH_PREFIX}/products/:docID/subdirectory`,
    exact: true,
    component: Loadable(import('../ui/apps/product/detail/subdirectory')),
  },
  {
    name: 'product.dropshipping.list',
    path: `${PATH_PREFIX}/dropshipping`,
    exact: true,
    component: Loadable(import('../ui/apps/product/dropshippingProduct/list')),
  },
  {
    name: 'product.dropshipping.price',
    path: `${PATH_PREFIX}/dropshipping/price/management`,
    exact: true,
    component: Loadable(
      import('../ui/apps/product/dropshippingProduct/priceManagement')
    ),
  },
  {
    name: 'product.dropshipping.inventory',
    path: `${PATH_PREFIX}/dropshipping/inventory/management`,
    exact: true,
    component: Loadable(
      import('../ui/apps/product/dropshippingProduct/inventoryManagement')
    ),
  },
  {
    name: 'product.dropshipping.dropshipper',
    path: `${PATH_PREFIX}/dropshipping/dropshipper`,
    exact: true,
    component: Loadable(
      import('../ui/apps/product/dropshippingProduct/dropshipper/overview')
    ),
  },
  {
    name: 'product.dropshipping.dropshipper.approved',
    path: `${PATH_PREFIX}/dropshipping/dropshipper/approved`,
    exact: true,
    component: Loadable(
      import(
        '../ui/apps/product/dropshippingProduct/dropshipper/approvedDropshipper'
      )
    ),
  },
  {
    name: 'product.dropshipping.dropshipper.approved.detail',
    path: `${PATH_PREFIX}/dropshipping/dropshipper/approved/:docID`,
    exact: true,
    component: Loadable(
      import(
        '../ui/apps/product/dropshippingProduct/dropshipper/approvedDropshipper/detail'
      )
    ),
  },
  {
    name: 'product.dropshipping.dropshipper.disapproved',
    path: `${PATH_PREFIX}/dropshipping/dropshipper/disapproved`,
    exact: true,
    component: Loadable(
      import(
        '../ui/apps/product/dropshippingProduct/dropshipper/disapprovedDropshipper'
      )
    ),
  },
  {
    name: 'product.dropshipping.dropshipper.pending',
    path: `${PATH_PREFIX}/dropshipping/dropshipper/pending`,
    exact: true,
    component: Loadable(
      import(
        '../ui/apps/product/dropshippingProduct/dropshipper/pendingDropshipper'
      )
    ),
  },
  {
    name: 'product.dropshipping.dropshipper.pending.detail',
    path: `${PATH_PREFIX}/dropshipping/dropshipper/pending/:docID`,
    exact: true,
    component: Loadable(
      import(
        '../ui/apps/product/dropshippingProduct/dropshipper/pendingDropshipper/detail'
      )
    ),
  },
  {
    name: 'product.dropshipped.list',
    path: `${PATH_PREFIX}/dropshipped`,
    exact: true,
    component: Loadable(import('../ui/apps/product/dropshippedProduct/list')),
  },
  {
    name: 'product.dropshipped.vendor',
    path: `${PATH_PREFIX}/dropshipped/vendors`,
    exact: true,
    component: Loadable(
      import('../ui/apps/product/dropshippedProduct/dropshippingVendor/list')
    ),
  },
  {
    name: 'product.dropshipped.vendor.detail',
    path: `${PATH_PREFIX}/dropshipped/vendors/:toCompanyID`,
    exact: true,
    component: Loadable(
      import('../ui/apps/product/dropshippedProduct/dropshippingVendor/detail')
    ),
  },
  {
    name: 'product.dropshipped.category',
    path: `${PATH_PREFIX}/dropshipped/category`,
    exact: true,
    component: Loadable(
      import(
        '../ui/apps/product/dropshippedProduct/dropshippedCategoryAssignment'
      )
    ),
  },
  {
    name: 'product.dropshipped.price',
    path: `${PATH_PREFIX}/dropshipped/price/management`,
    exact: true,
    component: Loadable(
      import(
        '../ui/apps/product/dropshippedProduct/dropshippedProductPriceManagement'
      )
    ),
  },
  {
    name: 'product.dropshipped.request',
    path: `${PATH_PREFIX}/dropshipped/request`,
    exact: true,
    component: Loadable(
      import(
        '../ui/apps/product/dropshippedProduct/dropshippedRequestForDropship/list'
      )
    ),
  },
  {
    name: 'product.dropshipped.request.detail',
    path: `${PATH_PREFIX}/dropshipped/request/:toCompanyID`,
    exact: true,
    component: Loadable(
      import(
        '../ui/apps/product/dropshippedProduct/dropshippedRequestForDropship/detail'
      )
    ),
  },
];
